export const TITLE_H1_STYLE = {
  fontWeight: 'bold',
  lineHeight: 1.4,
  // maxW: 'full',
  // whiteSpace: 'pre',
  fontSize: {
    base: '28px',
    md: '40px',
  },
  textAlign: {
    base: 'center',
    'lg+': 'left',
  },
}

export const TITLE_H2_STYLE = {
  fontWeight: 'bold',
  lineHeight: 1.4,
  fontSize: {
    base: '28px',
    md: '40px',
  },
  textAlign: {
    base: 'center',
    'lg+': 'left',
  },
}

export const TITLE_H3_STYLE = {
  fontWeight: 'bold',
  lineHeight: 1.4,
  fontSize: {
    base: '28px',
    md: '32px',
  },
  textAlign: {
    base: 'center',
    'lg+': 'left',
  },
}

export const PARAGRAPH_STYLE = {
  fontWeight: 'light',
  lineHeight: 1.6,
  fontSize: {
    base: 'lg',
    md: 'xl',
  },
  textAlign: {
    base: 'center',
    'lg+': 'left',
  },
}
